import React from 'react';
import './ProductStyle.css';

const FlatWiresAndProfiles = ({ open,onClose }) => {
    if(!open) return null
    return (
        <div className='overlay'>
            <div className='proContainer'>
                <button onClick={onClose} className='closeBtn'>X</button>
                <p> Flat Wires And Profiles</p>
                <div className='specs'>
                    <ul>
                        <li>Raw Material: <div>Low Carbon steel</div></li>
                        <li>Dimensions Range: <div>Thickness: 2mm - 12mm Width: 3mm - 20mm</div></li>
                        <li>Surface Quality: <div>Bright suitable for enamel, nickel plating, galvanizing or painting</div></li>
                        <li>Packing: <div>Spools (500kg - 1000kg) Straightened bars </div></li>
                        <li>Applications: <div> Home appliances and accessories</div></li>
                    </ul>
                </div>
                
            </div>
        </div>
    );
}
export default FlatWiresAndProfiles;
